export const getTime = () => {
  try {
    const time = new Date();
    return time.getTime();
  } catch (error) {
    return null;
  }
};

export const getDiff = time => {
  try {
    return getTime() - time;
  } catch (error) {
    return null;
  }
};

export const sleep = _time =>
  new Promise(resolve => {
    try {
      const time = _time > 500 ? 500 : _time;
      setTimeout(resolve, time);
    } catch (error) {
      resolve();
    }
  });
